var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 32,
    viewBox: "0 0 19 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.3333C1.007 21.3333 2.51071 22.3107 3.77286 23.3C5.40143 24.572 6.82236 26.092 7.90671 27.8347C8.71964 29.1413 9.5 30.7253 9.5 32M9.5 32C9.5 30.7253 10.2804 29.14 11.0933 27.8347C12.179 26.092 13.5999 24.572 15.2258 23.3C16.4893 22.3107 17.9957 21.3333 19 21.3333M9.5 32V0",
    stroke: "#D6E0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/Down_Arrow.a5a83dede723a2973951f303c269bdba.svg";
export { ForwardRef as ReactComponent };